import React from "react";
import moment from "moment";

export default function HourSelector({ available_hours, selected_hour, onChange }) {
  if (!available_hours) return null;
  return (
    <select onChange={onChange} value={moment(selected_hour).format("YYYY-MM-DD HH:mm")} >
      {available_hours.map((hour, index) => {
        return (
          <option
            // selected={moment(hour.hour).format("HH:mm") === moment(selected_hour).format("HH:mm")}
            key={moment(hour.hour).format("YYYY-MM-DD HH:mm")}
            value={moment(hour.hour).format("YYYY-MM-DD HH:mm")}
            disabled={hour.disabled}
          >
            {moment(hour.hour).format("HH:mm")}
          </option>
        )
      })
      }
    </select>
  );
}